'use strict';

require('./polyfills/foreach.js');

//Include theme scripts
require('./menu.js');
require('./sliders.js');
//require('./modals.js');
//require('./sticky-header.js');
require('./smooth-scroll.js');

class Theme {
	constructor(msg) {
		//console.log(msg)
	}
}

new Theme('hello');
